import { any, bool } from 'prop-types'
import styled from 'styled-components'

export const Collapse = ({ children, open }) => {
  return <Wrap open={open}>{children}</Wrap>
}

Collapse.propTypes = {
  children: any,
  open: bool.isRequired,
}

const Wrap = styled.div`
  display: ${({ open }) => (open ? 'block' : 'none')};
`
Wrap.propTypes = {
  ...Wrap.propTypes,
  open: bool.isRequired,
}
